/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { gql } from "@apollo/client";

export const CREATE_CSV_SEND_EMAIL = gql`
  mutation CreateCsvSendEmail(
    $createCsvSendEmailRequest: CreateCsvSendEmailRequest!
  ) {
    createCsvSendEmail(createCsvSendEmailRequest: $createCsvSendEmailRequest) {
      ok
      recipient
      reason
    }
  }
`;

export const DEACTIVATE_USER = gql`
  mutation DeactivateUser {
    deactivateUser {
      ok
    }
  }
`;

export const DEACTIVATE_USER_FROM_ORG = gql`
  mutation DeactivateUserFromOrg(
    $deactivateUserFromOrgRequest: DeactivateUserFromOrgRequest!
  ) {
    deactivateUserFromOrg(
      deactivateUserFromOrgRequest: $deactivateUserFromOrgRequest
    ) {
      ok
    }
  }
`;

export const DECLARE_MATCH_READY = gql`
  mutation DeclareMatchReady(
    $declareMatchReadyRequest: DeclareMatchReadyRequest!
  ) {
    declareMatchReady(declareMatchReadyRequest: $declareMatchReadyRequest) {
      ok
    }
  }
`;

export const DECLARE_MATCH_STEP_READY = gql`
  mutation DeclareMatchStepReady(
    $declareMatchStepReadyRequest: DeclareMatchStepReadyRequest!
  ) {
    declareMatchStepReady(
      declareMatchStepReadyRequest: $declareMatchStepReadyRequest
    ) {
      ok
    }
  }
`;

export const DECLARE_MATCH_CANCEL = gql`
  mutation DeclareMatchCancel(
    $declareMatchCancelRequest: DeclareMatchCancelRequest!
  ) {
    declareMatchCancel(declareMatchCancelRequest: $declareMatchCancelRequest) {
      ok
    }
  }
`;

export const DECLARE_MATCH_END = gql`
  mutation DeclareMatchEnd($declareMatchEndRequest: DeclareMatchEndRequest!) {
    declareMatchEnd(declareMatchEndRequest: $declareMatchEndRequest) {
      ok
      reason
      isCancelled
    }
  }
`;

export const SUBMIT_FEEDBACK = gql`
  mutation SubmitFeedback($submitFeedbackRequest: SubmitFeedbackRequest!) {
    submitFeedback(submitFeedbackRequest: $submitFeedbackRequest) {
      ok
      reason
    }
  }
`;

export const SUBMIT_ANSWERS = gql`
  mutation SubmitAnswers($submitAnswersRequest: SubmitAnswersRequest!) {
    submitAnswers(submitAnswersRequest: $submitAnswersRequest) {
      ok
      reason
    }
  }
`;

export const REPORT_ISSUE = gql`
  mutation ReportIssue($reportIssueRequest: ReportIssueRequest!) {
    reportIssue(reportIssueRequest: $reportIssueRequest) {
      ok
      reason
    }
  }
`;

export const REPORT_SESSION_PROBLEM = gql`
  mutation reportSessionProblem(
    $reportSessionProblemRequest: ReportSessionProblemRequest!
  ) {
    reportSessionProblem(
      reportSessionProblemRequest: $reportSessionProblemRequest
    ) {
      ok
      reason
    }
  }
`;

export const EDIT_SUMMIT = gql`
  mutation EditSummit($editSummitMutationRequest: EditSummitMutationRequest!) {
    editSummit(editSummitMutationRequest: $editSummitMutationRequest) {
      ok
      reason
    }
  }
`;

export const CREATE_SUMMIT = gql`
  mutation CreateSummit(
    $createSummitMutationRequest: CreateSummitMutationRequest!
  ) {
    createSummit(createSummitMutationRequest: $createSummitMutationRequest) {
      ok
      reason
      summitId
    }
  }
`;

export const CREATE_OR_GET_SUMMIT_SHARE_LINK = gql`
  mutation CreateOrGetSummitShareLink(
    $createOrGetSummitShareLinkMutationRequest: CreateOrGetSummitShareLinkMutationRequest!
  ) {
    createOrGetSummitShareLink(
      createOrGetSummitShareLinkMutationRequest: $createOrGetSummitShareLinkMutationRequest
    ) {
      ok
      reason
      inviteUuid
    }
  }
`;

export const EDIT_SKALESESSION = gql`
  mutation EditSkalesession(
    $editSkalesessionMutationRequest: EditSkalesessionMutationRequest!
  ) {
    editSkalesession(
      editSkalesessionMutationRequest: $editSkalesessionMutationRequest
    ) {
      ok
      reason
      isCancelled
      allowSharing
      masteryEdited
    }
  }
`;

export const CREATE_ANNOUNCEMENT = gql`
  mutation CreateAnnouncement(
    $createAnnouncementMutationRequest: CreateAnnouncementMutationRequest!
  ) {
    createAnnouncement(
      createAnnouncementMutationRequest: $createAnnouncementMutationRequest
    ) {
      ok
      reason
    }
  }
`;

export const EDIT_ANNOUNCEMENT = gql`
  mutation EditAnnouncement(
    $editAnnouncementMutationRequest: EditAnnouncementMutationRequest!
  ) {
    editAnnouncement(
      editAnnouncementMutationRequest: $editAnnouncementMutationRequest
    ) {
      ok
      reason
    }
  }
`;

export const DELETE_ANNOUNCEMENT = gql`
  mutation DeleteAnnouncement(
    $deleteAnnouncementMutationRequest: DeleteAnnouncementMutationRequest!
  ) {
    deleteAnnouncement(
      deleteAnnouncementMutationRequest: $deleteAnnouncementMutationRequest
    ) {
      ok
      reason
    }
  }
`;

export const PRIMARY_JOIN_ORG = gql`
  mutation PrimaryJoinOrg($primaryJoinOrgRequest: PrimaryJoinOrgRequest!) {
    primaryJoinOrg(primaryJoinOrgRequest: $primaryJoinOrgRequest) {
      ok
      id
      reason
    }
  }
`;

export const EDIT_SKILL_MODULE = gql`
  mutation EditSkillModule($editSkillModuleRequest: EditSkillModuleRequest!) {
    editSkillModule(editSkillModuleRequest: $editSkillModuleRequest) {
      ok
      reason
      skillModule {
        id
        name
        order
        description
        isActive
        canBeReviewed
        activeSkillList {
          edges {
            node {
              id
              order
              name
              description
              isPublished
              isActive
              areRatingsEnabled
            }
          }
        }
      }
    }
  }
`;

export const EDIT_SKILL = gql`
  mutation EditSkill($editSkillRequest: EditSkillRequest!) {
    editSkill(editSkillRequest: $editSkillRequest) {
      ok
      reason
      skill {
        id
        name
        order
        description
        isActive
        isPublished
        areRatingsEnabled
      }
      message
    }
  }
`;

export const CREATE_SKILL_MODULE = gql`
  mutation CreateSkillModule(
    $createSkillModuleRequest: CreateSkillModuleRequest!
  ) {
    createSkillModule(createSkillModuleRequest: $createSkillModuleRequest) {
      ok
      reason
      skillModule {
        id
        name
        order
        description
        isActive
        canBeReviewed
      }
    }
  }
`;

export const CREATE_SKILL = gql`
  mutation CreateSkill($createSkillRequest: CreateSkillRequest!) {
    createSkill(createSkillRequest: $createSkillRequest) {
      ok
      reason
      skill {
        id
        name
        order
        description
        isActive
        isPublished
        areRatingsEnabled
      }
    }
  }
`;

export const EDIT_STAFF_USER = gql`
  mutation EditUser($editUserRequest: EditUserRequest!) {
    editUser(editUserRequest: $editUserRequest) {
      ok
      reason
      isAdmin
      isStaff
      isManager
      isTrainer
      isCoach
    }
  }
`;

export const UPDATE_TIME_WINDOW = gql`
  mutation UpdateTimeWindow(
    $updateTimeWindowRequest: UpdateTimeWindowRequest!
  ) {
    updateTimeWindow(updateTimeWindowRequest: $updateTimeWindowRequest) {
      ok
      reason
      timeWindowId
    }
  }
`;

export const DEACTIVATE_TIME_WINDOW = gql`
  mutation DeactivateTimeWindow(
    $deactivateTimeWindowRequest: DeactivateTimeWindowRequest!
  ) {
    deactivateTimeWindow(
      deactivateTimeWindowRequest: $deactivateTimeWindowRequest
    ) {
      ok
      reason
    }
  }
`;

export const APPROVE_KUDOS = gql`
  mutation ApproveKudos($approveKudosRequest: ApproveKudosRequest!) {
    approveKudos(approveKudosRequest: $approveKudosRequest) {
      ok
      reason
    }
  }
`;

export const LOG_SESSION_VIEW = gql`
  mutation LogSessionView($logSessionViewRequest: LogSessionViewRequest!) {
    logSessionView(logSessionViewRequest: $logSessionViewRequest) {
      ok
      reason
    }
  }
`;

export const SEND_KUDOS = gql`
  mutation sendKudos($sendKudosRequest: SendKudosRequest!) {
    sendKudos(sendKudosRequest: $sendKudosRequest) {
      ok
      reason
    }
  }
`;
